import React, { useContext, useEffect, useState } from 'react';
import {
  CircularProgress, Grid, Alert,
} from '@mui/material';
import styled from 'styled-components';
import { AppContext } from '../../providers/authProvider';
import api from '../../api/req';
import Diagram from './diagram';

const LoaderContainer = styled.div`
  position: fixed;
  left: 50vw;
  top: 50vh;

  & > div {
    margin-left: -50%;
    margin-top: -50%;
  }
`;

function Dashboards() {
  const { auth } = useContext(AppContext);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  useEffect(
    () => {
      const loader = async () => {
        const r = await api.get('/api/reports/dashboard/', auth);
        if (!r.ok) {
          throw new Error(`${r.status} ${r.statusText}`);
        }
        return r.json();
      };
      setErr(null);
      setLoading(true);
      loader()
        .then((d) => setItems(d))
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    },
    [auth],
  );
  return (
    <div style={{ marginTop: '2rem' }}>
      {err && (
        <Alert severity="error">
          {err}
        </Alert>
      )}
      {loading && (
        <LoaderContainer>
          <div>
            <CircularProgress />
          </div>
        </LoaderContainer>
      )}
      <Grid container spacing={2}>
        {items.map((item) => (
          <Grid key={item.id} item sm={6}>
            <Diagram url={item.url} title={item.name} id={item.id} options={item.options} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Dashboards;
